const ChatWhiteIcon = () => (
  <div>
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 25.3327H10.6667C5.33332 25.3327 2.66666 23.9993 2.66666 17.3327V10.666C2.66666 5.33268 5.33332 2.66602 10.6667 2.66602H21.3333C26.6667 2.66602 29.3333 5.33268 29.3333 10.666V17.3327C29.3333 22.666 26.6667 25.3327 21.3333 25.3327H20.6667C20.2533 25.3327 19.8533 25.5327 19.6 25.866L17.6 28.5327C16.72 29.706 15.28 29.706 14.4 28.5327L12.4 25.866C12.1867 25.5727 11.6933 25.3327 11.3333 25.3327Z"
        stroke="#F7F9FD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3286 14.6667H21.3406"
        stroke="#F7F9FD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.994 14.6667H16.0059"
        stroke="#F7F9FD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6593 14.6667H10.6713"
        stroke="#F7F9FD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default ChatWhiteIcon;
